import type from './constants';

const initState = {
    params: {},
    searchParams: {},
}

export default (state = initState, actions) => {
    switch(actions.type) {
        case type.SAVE_PARAMS:
            return {
                ...state,
                params: {
                    ...state.params,
                    ...actions.params,
                },
            };
        case type.SAVE_SEARCHPARAMS:
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    ...actions.params,
                },
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/homePage/afficheNews/store/reducer.js